module.exports = __webpack_public_path__ + "static/media/img2.38d52c2c.png";